export default __webpack_public_path__ + "media/images/favicon/favicon-96x96-101108439b994f5159d20549b2e295de.png";